module.exports = __webpack_public_path__ + "static/media/asset_3.6a17075a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/asset_3.jpg
// module id = 310
// module chunks = 0